import React from 'react';

const formatARS = (value) =>
    value != null
        ? new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 }).format(value)
        : '';

const formatPeriodo = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
};

const PdfResumen = ({ resumen = [], periodo }) => {
    const secciones = resumen.reduce((acc, row) => {
        const key = row.Seccion || '';
        if (!acc[key]) acc[key] = [];
        acc[key].push(row);
        return acc;
    }, {});

    return (
        <>
            <div className="pdf-section-title">
                RESUMEN DE INGRESOS Y EGRESOS — {formatPeriodo(periodo)?.toUpperCase()}
            </div>
            <table className="pdf-data-table">
                <thead>
                    <tr>
                        <th>Concepto</th>
                        <th className="pdf-col-number">Importe</th>
                    </tr>
                </thead>
                <tbody>
                    {resumen.length === 0 ? (
                        <tr>
                            <td colSpan={2} style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                Sin datos de resumen
                            </td>
                        </tr>
                    ) : (
                        Object.entries(secciones).map(([seccion, rows]) => {
                            const subtotal = rows.reduce((sum, r) => sum + (r.Importe || 0), 0);
                            return (
                                <React.Fragment key={seccion}>
                                    <tr className="pdf-row-section-header">
                                        <td colSpan={2}>{seccion}</td>
                                    </tr>
                                    {rows.map((row, i) => (
                                        <tr key={i}>
                                            <td className="pdf-col-indent">{row.Concepto}</td>
                                            <td className="pdf-col-number">{formatARS(row.Importe)}</td>
                                        </tr>
                                    ))}
                                    <tr className="pdf-row-subtotal">
                                        <td className="pdf-col-indent">Total {seccion}</td>
                                        <td className="pdf-col-number">{formatARS(subtotal)}</td>
                                    </tr>
                                </React.Fragment>
                            );
                        })
                    )}
                </tbody>
            </table>
        </>
    );
};

export default PdfResumen;
